import ajax from '../../lib/ajax'
export async function QueryPurPurchaseReceiptList(payload:any) {
    let res = await ajax.post('api/services/app/Purchase/QueryPurPurchaseReceiptList',payload,false)
    return res.data.result
}
export async function QueryPurchaseReceiptDetail(payload:any) {
    let res = await ajax.post('api/services/app/Purchase/QueryPurchaseReceiptDetail?PurPurchaseReceiptId='+payload.PurPurchaseReceiptId,{},false)
    return res.data.result
}
export async function PurShippingReceipt(payload:any) {
    let res = await ajax.post('api/services/app/Purchase/PurShippingReceipt',payload)
    return res.data.result
}
export async function QueryTenant(payload:any) {
    let res = await ajax.post('api/services/app/Purchase/QueryTenant',payload,false)
    return res.data.result
}
export async function QueryShippingReceiptList(payload:any) {
    let res = await ajax.post('api/services/app/Purchase/QueryShippingReceiptList',payload,false)
    return res.data.result
}
export async function QueryShippingReceiptDetai(payload:any) {
    let res = await ajax.post('api/services/app/Purchase/QueryShippingReceiptDetai?ShippingReceiptId='+payload.ShippingReceiptId,{},false)
    return res.data.result
}